module.exports = {
    GET_SORT_BY_LIST_URL: '/getSortByList.action?parameterString=',
    GET_SORT_BY_LIST_API_URL: '/apiGetSortList.action?parameterString=',
    FILTER_REQUEST_RESPONSE_URL: '/apiGetFilterUrl.action',
    FILTER_REQUEST_DATA_URL: '/apiGetFilters.action',
    MOBILE_FILTER_REQUEST_DATA_URL: '/apiGetMobileFilters.action',
    CATEGORIES_REQUEST_DATA_URL: '/apiMobileCategoryFilter.action',
    API_KEY: '77C853DB4B659459004A1387AC365A03',
    TRACK_MOBILE_SEARCH_BAR: 'MobileBar',
    TRACK_FILTER_USAGE: 'TrackFilterOpens',
    FILTER_SALE_CHECKBOX_NAME: 'salefilter',
    FILTER_FREESHIPPING_CHECKBOX_NAME: 'freeshippingfilter'
};
